import { Tooltip } from "antd";
import React, { useEffect } from "react";
import styles from "./location.module.scss";
import ChatLike from "../chatLike";
import ChatHoverOption from "../chatHoverOption";
import ChatUserInfo from "../chatUserInfo";
import ChatRightInfo from "../chatRightInfo";
import moment from "moment";
import { useSelector } from "react-redux";
import { chats, initialStateModel } from "../../../../models/model";
import { ChatService } from "../../../../base/chatService";
import { config } from "../../../../base/constant";
import ForwardHeader from "../forwardHeader";
import ChatLeftInfo from "../chatLeftInfo";
//import { getdateFormat } from "../../../../base/utils";
//const LocationCoordinates = ({ text }: any) => <div>{text}</div>;
type locationProps = {

  data: any;
  searchedData?: any;
  savedData?: any;
  previousItem?: any;
};
export default function ChatMapLocation({ data, savedData, previousItem }: locationProps) {
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);

  useEffect(() => {


  }, [savedData]);
  try{
  var daysDifference: any = 11;
  let { message, direction, timestamp, fromcaller_details, id } = data;
  let htimestamp = moment(timestamp).format('hh:mm');
  let hovertimestamp = moment(timestamp).format('hh:mm A');
  var difference = timestamp - previousItem?.timestamp;
  let isReply =  data.message?.isReply;
  if (!data?.message?.isReply && !data?.message?.liked && !data?.isEdit) {
    daysDifference = previousItem?.timestamp === undefined ? 11 : Math.floor(difference / 1000 / 60);
  }
  const center = {
    lat: message.body.lat,
    lng: message.body.lan
  };
  const handleOnChange = (data: any) => {
    if (chatReducer?.isDelete || chatReducer?.isForward) {
      ChatService.selectedMessageDispatch(data);
    }
  };

  const handlehighlightHover = () => {
    var element: HTMLElement | any = document.getElementById(id) || null;
    if (element != null) {
      element.classList.add("highlighthover");
    }
  };

  const googleMapURL = `https://www.google.com/maps/embed/v1/place?key=${config().GOOGLE_DEVELOPER_KEY}&q=${center.lat},${center.lng}`;


  return (
    <>
    {direction === "IN" ? (

      <div className={`${chatReducer.isSaveChat &&
        id === savedData ? 'savedhighlight' : ""
        } ${styles.chatMsg} ${styles.leftMessage}`} id={id} onClick={() => handleOnChange(data)}>
        {!isReply &&daysDifference > 6 && <div className={`${styles.chatUserDetails}`}>
          <ChatUserInfo userDetails={fromcaller_details} className='userinfoIcon leftSide' />
          <div className={styles.convMemName}><span>{fromcaller_details?.caller_id}</span></div>
        </div>}
        <div className={styles.chatLeftMessages}>
          <div className={styles.chatLeft}>
            
            {!isReply && <Tooltip title={hovertimestamp} className='cusTooltip' overlayClassName='customTooltip'>
              <div className={styles.chatTime}>{htimestamp}</div></Tooltip>}
            <div className={styles.chatContent}>
            {data?.message?.forward && <ForwardHeader />} 
              <div className="maplocationcustom">
              <iframe frameBorder="0" style={{"border":"0"}} title="Location"
              referrerPolicy="no-referrer-when-downgrade" 
              src={googleMapURL} allowFullScreen>
              </iframe>
              </div>
              <ChatLeftInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} timeStamp={timestamp} message={data}></ChatLeftInfo>

              <ChatLike className='likeLeft' placement="top"
                tooltipTitle={data?.likeduserdetails}
                message={data} />
                  {!isReply &&  <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
                    <ChatHoverOption className='hoverList hoverListleft' data={data} highlightHover={handlehighlightHover} /></div>}
               
            </div>
          </div>
        </div>
       
      
      </div>

    )
: (
  <div  className={`${chatReducer.isSaveChat&& id===savedData?'savedhighlight':""} ${styles.chatMsg} ${styles.rightMessage} 
  : ""}`
  }   id={id} >
   {!isReply &&daysDifference >6 &&  <div className={`${styles.chatUserDetails}`}>
   <div className={styles.convMemName}><span>You</span></div>
    <ChatUserInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} className='userinfoIcon rightSide' />
          
    </div>}
  
    
    <div className={styles.chatRightMessages} >
    <div className={styles.chatRight} >

        <div className={styles.chatContent} >
        {data?.message?.forward && <ForwardHeader />} 
        <div className="maplocationcustom">
        <iframe frameBorder="0" style={{"border":"0"}} title="Location"
              referrerPolicy="no-referrer-when-downgrade" 
              src={googleMapURL} allowFullScreen>
        </iframe>
              </div>

        
              <ChatRightInfo userDetails={fromcaller_details===undefined?'Unknown User':fromcaller_details} timeStamp={timestamp}
                    message={data} ></ChatRightInfo>
                  
          <ChatLike className='likeRight' placement="topRight"
                    tooltipTitle={data?.likeduserdetails} message={data} />
{/*                   
                  {!isReply  && <Tooltip  placement="topRight" title={hovertimestamp}
          className='cusTooltip' overlayClassName='customTooltip'>
                    <div className={styles.chatTime}>{daysDifference < 5 ? htimestamp : htimestamp}</div></Tooltip>} */}
        </div>
       
      
      </div>
    </div>
   
    <div className={`chatInnerHoveroptn ${styles.hoverOptions}`}>
   
      <ChatHoverOption className='hoverList hoverListright' data={data} highlightHover={handlehighlightHover}/></div>

    {/* Need to handle */}
   
  </div>
)

    }
    </>
  );
} catch(e){
  return <p style={{color: 'red'}}>Something went wrong</p>;
}
};

